import React, { useEffect, useState } from "react";
import "../../assets/css/Faqs.css";
import { Link } from "react-router-dom";
import Header from "../../Components/Header/Header";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import SpinLoader from "../../Components/Loader/SpinLoader";
import { GetFaqs } from "../../network/Network";
import Skeleton from "react-loading-skeleton";

function Faqs() {
	const [faqsData, setFaqsData] = useState([]);
	const [spinLoad, setSpinLoad] = useState(false);
	useEffect(() => {
	  setSpinLoad(true);
	  GetFaqs()
		.then((res) => {
		  setFaqsData(res?.data);
		  setSpinLoad(false);
		})
		.catch((err) => {
		  setSpinLoad(false);
		});
	}, []);
  
	useEffect(() => {
	  window.scrollTo(0, 0);
	}, []);


	return (
		<>
			<Header />
			<MainBanner name={"FAQ's"} />

			<section className="faqs_sec">
				<div className="container">
					<div className="row">
						<div className="col-lg-2"></div>
						<div className="col-lg-8">
							<div className="heading">
								<h2>Questions Answerd</h2>
								<p>
									Nisl vel pretium lectus quam id leo. Odio ut enim blandit
									volutpat maecenas volutpat blandit. Nunc vel risus commodo
									viverra maecenas. Lacus luctus accumsan tortor posuere ac ut
									consequat.
								</p>
							</div>
							<div className="accordion" id="accordionExample">
								{spinLoad ? (
									<>
										{[0, 1, 2, 3, 4, 5]?.map((item, index) => {
											return (
												<div className="col-md-12 mt-3" key={index}>
													<Skeleton count={5} />
												</div>
											);
										})}
									</>
								) : (
									<>
										<div id="accordion">
											{faqsData?.map((item, index) => {
												return (
													<div className="card mt-2" key={index}>
														<div className="card-header" id={item?.id}>
															<h5 className="mb-0">
																<button
																	className="btn btn-link accordion-button"
																	data-toggle="collapse"
																	data-target={`#${item?.question}${item?.id}`}
																	aria-expanded="true"
																	aria-controls={`${item?.question}${item?.id}`}
																>
																	{item?.question}
																</button>
															</h5>
														</div>

														<div
															// id="collapseOne"
															className="collapse show"
															// aria-labelledby="headingOne"
															data-parent="#accordion"
															id={`${item?.question}${item?.id}`}
															aria-labelledby={item?.id}
														>
															<div className="card-body">
																<p
																	dangerouslySetInnerHTML={{
																		__html: item?.answer,
																	}}
																/>
															</div>
														</div>
													</div>
												);
											})}
										</div>
									</>
								)}
							</div>
						</div>
						<div className="col-lg-2"></div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
}

export default Faqs;